import {
  NotificationState,
  NotificationListSerialization,
  NotificationItem,
  NotificationReadStatusEnum,
} from "../types";

import {
  TicketsIcon,
  ReleaseIcon,
  SprintIcon,
  MembersIcons,
  ProjectIcon,
  CalendarIcon,
} from "app/components/Icons";
import { dateFormatter } from "utils/helpers";

export const updateFilteredNotifications = (state: NotificationState) => {
  const unarchivedNotifications = state.notifications.filter(
    (n) => !n.isArchived,
  );
  switch (state.activeTab) {
    case NotificationReadStatusEnum.UNREAD:
      state.filteredNotifications = unarchivedNotifications.filter(
        (n) => n.isUnread || (n.actions && n.actions.length > 0),
      );
      break;
    case "critical":
      state.filteredNotifications = unarchivedNotifications.filter(
        (n) => n.actions && n.actions.length > 0,
      );
      break;
    default:
      state.filteredNotifications = unarchivedNotifications;
      break;
  }
};

export const mapApiToNotificationItem = (
  notification: NotificationListSerialization,
): NotificationItem => {
  let icon: any = TicketsIcon;
  let iconColor = "#9333ea";
  let bgClass = "bg-purple-50";
  let type: NotificationItem["type"] = "ticket";

  const category = notification.category.toLowerCase();

  switch (category) {
    case "release":
    case "releases":
      icon = ReleaseIcon;
      iconColor = "#db2777";
      bgClass = "bg-pink-50";
      type = "release";
      break;
    case "sprint":
    case "sprints":
      icon = SprintIcon;
      iconColor = "#0891b2";
      bgClass = "bg-cyan-50";
      type = "sprint";
      break;
    case "teams":
    case "team":
      icon = MembersIcons;
      iconColor = "#2563eb";
      bgClass = "bg-blue-50";
      type = "team";
      break;
    case "projects":
    case "project":
      icon = ProjectIcon;
      iconColor = "#ea580c";
      bgClass = "bg-orange-50";
      type = "project";
      break;
    case "calendar":
    case "calendars":
      icon = CalendarIcon;
      iconColor = "#d97706";
      bgClass = "bg-amber-50";
      type = "calendar";
      break;
    default:
      icon = TicketsIcon;
      iconColor = "#9333ea";
      bgClass = "bg-purple-50";
      type = "ticket";
  }

  const title =
    notification.context?.ticketTitle || notification.type || "Notification";
  const description = notification.context?.description || "";

  // Format the time as a simple readable string
  let timeStr = "";
  try {
    timeStr = dateFormatter(notification.createdAt, "datetime");
  } catch (e) {
    timeStr = notification.createdAt;
  }

  // Derive actions if necessary (mimicking mock data)
  let actions: any[] | undefined = undefined;
  if (notification.type === "TEAM_INVITATION") {
    actions = [
      { label: "Join Team", variant: "primary" },
      { label: "Reject Invitation", variant: "secondary" },
    ];
  } else if (
    notification.type === "SPRINT_RETROSPECTIVE_REQUEST" ||
    notification.context?.description?.includes("retrospective")
  ) {
    actions = [{ label: "Submit", variant: "primary" }];
  } else if (category === "calendar" && notification.type?.includes("REPORT")) {
    actions = [
      { label: "Report Time", variant: "primary" },
      { label: "Report Day Off", variant: "secondary" },
    ];
  }

  return {
    id: notification._id,
    icon,
    title,
    time: timeStr,
    description,
    type,
    isUnread: !notification.isRead,
    isArchived: notification.isArchived,
    iconColor,
    bgClass,
    actions,
    meta: notification.context,
    eventType: notification.type,
  };
};
